module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-white-3c89b1153057c71deb57b170bb6a9ca7.png";